import React from "react";
import "./Familiar.css";
import check from "../../assets/images/Lp/check.png";
import cross from "../../assets/images/Lp/cross.png";
import Image01 from "../../assets/images/Lp/fam-icon-01.png";
import Image02 from "../../assets/images/Lp/fam-icon-02.png";
import Image03 from "../../assets/images/Lp/fam-icon-03.png";
import Image04 from "../../assets/images/Lp/fam-icon-04.png";
import Image05 from "../../assets/images/Lp/fam-icon-05.png";

const Box_data = [
  {
    id: 1,
    img: Image04,
    check: cross,
    desc: "You offer attractive customer discounts, especially on first-time customers",
  },
  {
    id: 1,
    img: Image03,
    check: cross,
    desc: "Your margins are slim, or even negative on these discounted orders",
  },
  {
    id: 1,
    img: Image02,
    check: cross,
    desc: "Customers create multiple email accounts to exploit your generosity",
  },
  {
    id: 1,
    img: Image01,
    check: cross,
    desc: "Shopify only checks for unique email addresses and doesn't catch them",
  },
  {
    id: 1,
    img: Image05,
    check: check,
    desc: "<span class='accent'>CustomerGenius</span> proactively stops discount abusers using advanced checks, protecting your margins and saving your time.",
  },
];
export default function Familiar({ id }) {
  return (
    <div id={id} className="section py-constant bg-light">
      <div className="container">
        <h2 className="h2 title center">
          Recognize these issues affecting <br></br>your
          <span className="accent"> store's profitability?</span>
        </h2>
        <div className="flex flex-row boxes">
          {Box_data.map((item) => {
            return (
              <div className="box-wrap">
                <img src={item.check} width={35} alt="" className="icon" />
                <img src={item.img} width={60} alt="" className="image" />

                <div
                  className="text-md"
                  dangerouslySetInnerHTML={{ __html: item.desc }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
